import { useAdvertListData, useAdvertFavoriteService, apiAdvertFavoriteRemoveAdvert } from '@edikk-edikk/ui';
import { apiAdvertListToggleIsFavorite } from '#advertList/api/api-advert-list-toggle-is-favorite';
import { useAppDispatch } from '#components/redux/hooks';
import { useApi } from '#hooks/use-api';

const useClickLogicForGuest = () => {
  const advertListData = useAdvertListData();
  const dispatch = useAppDispatch();
  const advertFavoriteService = useAdvertFavoriteService();
  const api = useApi();

  return (id: number, isFavorite: boolean) => {
    const cityId = advertListData.getCityId();
    const categoryId = advertListData.getCategoryId();
    const areaId = advertListData.getAreaId();

    if (isFavorite) {
      advertFavoriteService.remove(id);
      apiAdvertListToggleIsFavorite(api, id, cityId, categoryId, areaId, dispatch);
      apiAdvertFavoriteRemoveAdvert(api.getApiAdvertFavorite(), id, dispatch);
    } else {
      advertFavoriteService.add(id);
      apiAdvertListToggleIsFavorite(api, id, cityId, categoryId, areaId, dispatch);
    }
  };
};

export { useClickLogicForGuest };
